"use client";

import { usePathname } from "@i18n/next";
import type { ReactNode } from "react";

import { resolveBlocksFor } from "../../lib/accessRestrictions";
import { AccessRestrictedGate } from "./AccessRestrictedGate";

export const AccessRestrictedRouter = ({
  children,
}: {
  children: ReactNode;
}) => {
  const pathname = usePathname();
  const blocks = resolveBlocksFor(pathname);
  return (
    <AccessRestrictedGate blocks={blocks}>{children}</AccessRestrictedGate>
  );
};
